import React from "react";
import { shallow } from "zustand/shallow";

import useExplorerStore from "../../store/store";
import Collapsible from "../Collapsible";
import FundCard from "../FundCard";

const FundCardGroupedList = () => {
    const { groupedData, groupOptions, groupBy } = useExplorerStore(
        ({ groupedData, config: { groupOptions }, groupBy }) => ({
            groupedData,
            groupOptions,
            groupBy,
        }),
        shallow,
    );
    // const groupOption = groupOptions.find((o) => o.prop === groupBy);
    const ordering =
        // groupOption?.ordering ??
        Object.entries(groupedData).map(([groupingValue]) => groupingValue);
    const emptyGroup = (groupValue: string) =>
        Boolean(groupedData[groupValue]?.length);
    return (
        <>
            {ordering.filter(emptyGroup).map((groupValue) => (
                <Collapsible
                    key={groupValue}
                    label={groupValue}
                    labelClassNames="pl-4 py-2 my-1 font-medium w-full"
                    withChevron
                    isOpen
                >
                    <>
                        {groupedData[groupValue]?.map((fundId) => (
                            <FundCard key={fundId} fund={fundId} />
                        ))}
                    </>
                </Collapsible>
            ))}
        </>
    );
};

export default FundCardGroupedList;
